import { render, staticRenderFns } from "./RoofCalNewBtn.vue?vue&type=template&id=670375ae&scoped=true"
import script from "./RoofCalNewBtn.vue?vue&type=script&lang=js"
export * from "./RoofCalNewBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670375ae",
  null
  
)

export default component.exports